let cacheStorage = {};

export default {
  get: item => {
    if (cacheStorage[item]) {
      return cacheStorage[item];
    }
    const val = window.localStorage.getItem(item);
    if (val !== undefined && val !== 'undefined') {
      try {
        const data = JSON.parse(val);
        return data;
      } catch (err) {
        return val;
      }
    } else {
      return '';
    }
  },
  set: (key, value) => {
    cacheStorage[key] = value;
    window.localStorage.setItem(key, JSON.stringify(value));
  },
  remove: item => {
    cacheStorage[item] = '';
    window.localStorage.removeItem(item);
  },
  clear: () => {
    cacheStorage = {};
    window.localStorage.clear();
  }
};
